module.exports = __webpack_public_path__ + "static/media/chatfuel_ai.00dfd0a3.png";